// DEV-55. Понятный текст на выключенную одношаговую регистрацию.
//
// Сервер (DEV-51, РГ-03) оставил старый маршрут `POST /registration`
// объявленным, но отвечает на него `410`: регистрация переведена на три шага
// (`start → confirm → complete`). Прежний фронт показывал на это молчаливую
// ошибку — человек не понимал, что делать.

export const REGISTRATION_DISABLED_MESSAGE = "регистрация временно недоступна";

export const REGISTRATION_FAILED_MESSAGE = "не удалось зарегистрироваться";

/** Текст отказа для формы старой регистрации. `410` назван отдельно и понятно. */
export function registrationErrorMessage(error: any): string {
  const status = error?.response?.status;

  if (status === 410) {
    return REGISTRATION_DISABLED_MESSAGE;
  }

  return (
    error?.response?.data?.message ||
    error?.message ||
    REGISTRATION_FAILED_MESSAGE
  );
}
